import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-antaragni',
  templateUrl: './antaragni.component.html',
  styleUrls: ['./antaragni.component.scss']
})
export class AntaragniComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
